import { TB, GB } from "./size-units.js";
export const PlanNames = {
    /**
     * @deprecated
     */
    starterMonthly: 'starterMonthly',
    /**
     * @deprecated
     */
    starterAnnual: 'starterAnnual',
    /**
     * @deprecated
     */
    freeTrial: 'freeTrial',
    /**
     * @deprecated
     */
    freeTier: 'freeTier',
    // EARLY BIRD PLANS
    // People who have early bird plans will continue with the plans, and are
    // guaranteed no price increases until at least 2030. But we no longer
    // allow this plans to be purchased for new subscriptions
    /**
     * @deprecated
     */
    earlyBirdBasicMonthly: 'earlyBirdBasicMonthly',
    /**
     * @deprecated
     */
    earlyBirdBasicAnnual: 'earlyBirdBasicAnnual',
    // This name has a typo, but we live with it cause it's already in the DB.
    // Changing it will cause things to break unless all DB records that reference
    // it are also updated.
    /**
     * @deprecated
     */
    earlyBirdStarterMonthly: 'earlyBirdStartMonthly',
    /**
     * @deprecated
     */
    earlyBirdStarterAnnual: 'earlyBirdStarterAnnual',
    /**
     * @deprecated
     */
    earlyBirdProMonthly: 'earlyBirdProMonthly',
    /**
     * @deprecated
     */
    earlyBirdProAnnual: 'earlyBirdProAnnual',
    /**
     * @deprecated
     */
    earlyBirdBusinessAnnual: 'earlyBirdBusinessAnnual',
    /**
     * @deprecated
     */
    earlyBirdBusinessMonthly: 'earlyBirdBusinessMonthly',
    // ACTIVE PLANS
    soloMonthly: 'soloMonthly',
    soloAnnual: 'soloAnnual',
    liteMonthly: 'liteMonthly',
    liteAnnual: 'liteAnnual',
    proMonthly: 'proMonthly',
    proAnnual: 'proAnnual',
    businessMonthly: 'businessMonthly',
    businessAnnual: 'businessAnnual'
};
export const PlanList = [
    // LEGACY PLANS, do not delete
    {
        name: PlanNames.starterMonthly,
        displayName: 'Quickbyte Starter - Monthly',
        maxStorageSize: 500 * GB,
        maxTransferSize: 200 * GB,
        renewalRate: 'monthly',
        maxTransferValidity: 30,
        allowPurchase: false,
        allowRenew: false,
        maxMembers: 3,
        maxProjects: Infinity,
        defaultPrice: {
            amount: 900,
            currency: 'KES'
        },
    },
    {
        name: PlanNames.starterAnnual,
        displayName: 'Quickbyte Starter - Annual',
        maxStorageSize: 500 * GB,
        maxTransferSize: 200 * GB,
        renewalRate: 'annual',
        maxTransferValidity: 30,
        allowPurchase: false,
        allowRenew: false,
        maxMembers: 2,
        maxProjects: Infinity,
        defaultPrice: {
            amount: 9000,
            currency: 'KES'
        },
    },
    {
        name: PlanNames.freeTrial,
        displayName: 'Quickbyte Free Trial',
        maxStorageSize: 500 * GB,
        maxTransferSize: 200 * GB,
        renewalRate: 'monthly',
        maxTransferValidity: 15,
        allowPurchase: false,
        allowRenew: false,
        maxMembers: 10,
        maxProjects: 1,
        defaultPrice: {
            amount: 0,
            currency: 'KES'
        },
    },
    // NEW PLANS
    {
        name: PlanNames.freeTier,
        displayName: 'Free',
        // Free tier limit is set to a high value
        // instead of a low figure like 2GB because
        // only anonymous temporary accounts can
        // access the free tier, and their
        // accounts will be deleted
        // if they don't purchase a subscription
        // before their session expire.
        // If we ever allow free tier for 
        // "persistent accounts", we should revise this figure.
        maxStorageSize: 100 * GB,
        maxTransferSize: 100 * GB,
        renewalRate: 'monthly',
        allowPurchase: false,
        allowRenew: true,
        // Allow multiple members for free tier
        // since free tier is only accessible
        // to temporary accounts. The
        // user will have to purchase a subscription
        // to persist the account.
        maxMembers: 2,
        maxProjects: 1,
        defaultPrice: {
            amount: 0,
            currency: 'USD'
        },
    },
    // EARLY BIRD
    // These are retired. Existing plans will continue to be supported
    // and are guaranteed of no price increase until 2030.
    // But these plans cannot be purchased for new subscriptions
    {
        name: PlanNames.earlyBirdBasicMonthly,
        displayName: 'Early Bird Basic',
        maxTransferSize: 50 * GB,
        maxStorageSize: 300 * GB,
        renewalRate: 'monthly',
        allowPurchase: false,
        allowRenew: true,
        maxMembers: 1,
        maxProjects: 2,
        defaultPrice: {
            amount: 500,
            currency: 'KES'
        },
    },
    {
        name: PlanNames.earlyBirdBasicAnnual,
        displayName: 'Early Bird Basic',
        maxTransferSize: 50 * GB,
        maxStorageSize: 300 * GB,
        renewalRate: 'annual',
        allowPurchase: false,
        allowRenew: true,
        maxMembers: 1,
        maxProjects: 2,
        defaultPrice: {
            amount: 4_800,
            currency: 'KES'
        },
    },
    {
        name: PlanNames.earlyBirdStarterMonthly,
        displayName: 'Early Bird Starter',
        maxTransferSize: 200 * GB,
        maxStorageSize: 1 * TB,
        renewalRate: 'monthly',
        allowPurchase: false,
        allowRenew: true,
        maxMembers: 2,
        maxProjects: Infinity,
        defaultPrice: {
            amount: 1_000,
            currency: 'KES'
        },
    },
    {
        name: PlanNames.earlyBirdStarterAnnual,
        displayName: 'Early Bird Starter',
        maxTransferSize: 200 * GB,
        maxStorageSize: 1 * TB,
        renewalRate: 'annual',
        allowPurchase: false,
        allowRenew: true,
        maxMembers: 2,
        maxProjects: Infinity,
        defaultPrice: {
            amount: 9_000,
            currency: 'KES'
        },
    },
    // Early Bird Team
    {
        name: PlanNames.earlyBirdProMonthly,
        displayName: 'Early Bird Pro',
        maxTransferSize: 1 * TB,
        maxStorageSize: 5 * TB,
        renewalRate: 'monthly',
        allowPurchase: false,
        allowRenew: true,
        maxMembers: 6,
        maxProjects: Infinity,
        defaultPrice: {
            amount: 4_000,
            currency: 'KES'
        },
    },
    {
        name: PlanNames.earlyBirdProAnnual,
        displayName: 'Early Bird Pro',
        maxTransferSize: 200 * GB,
        maxStorageSize: 5 * TB,
        renewalRate: 'annual',
        allowPurchase: false,
        allowRenew: true,
        maxMembers: 6,
        maxProjects: Infinity,
        defaultPrice: {
            amount: 38_000,
            currency: 'KES'
        },
    },
    // Early Bird Business
    {
        name: PlanNames.earlyBirdBusinessMonthly,
        displayName: 'Early Bird Business',
        maxTransferSize: 200 * GB,
        maxStorageSize: 25 * TB,
        renewalRate: 'monthly',
        allowPurchase: false,
        allowRenew: true,
        maxMembers: Infinity,
        maxProjects: Infinity,
        defaultPrice: {
            amount: 20_000,
            currency: 'KES'
        },
    },
    {
        name: PlanNames.earlyBirdBusinessAnnual,
        displayName: 'Early Bird Business',
        maxTransferSize: 200 * GB,
        maxStorageSize: 25 * TB,
        renewalRate: 'annual',
        allowPurchase: false,
        allowRenew: true,
        maxMembers: Infinity,
        maxProjects: Infinity,
        defaultPrice: {
            amount: 192_000,
            currency: 'KES'
        },
    },
    // ACTIVE PLANS
    // Solo
    {
        name: PlanNames.soloMonthly,
        displayName: 'Solo',
        maxTransferSize: 50 * GB,
        maxStorageSize: 300 * GB,
        renewalRate: 'monthly',
        allowPurchase: true,
        allowRenew: true,
        maxMembers: 1,
        maxProjects: Infinity,
        defaultPrice: {
            amount: 2.5,
            currency: 'USD'
        },
        regionPrices: {
            US: {
                amount: 2.5,
                currency: 'USD'
            },
            KE: {
                amount: 250,
                currency: 'KES'
            },
        }
    },
    {
        name: PlanNames.soloAnnual,
        displayName: 'Solo',
        maxTransferSize: 50 * GB,
        maxStorageSize: 300 * GB,
        renewalRate: 'annual',
        allowPurchase: true,
        allowRenew: true,
        maxMembers: 1,
        maxProjects: Infinity,
        defaultPrice: {
            amount: 25,
            currency: 'USD'
        },
        regionPrices: {
            US: {
                amount: 25,
                currency: 'USD'
            },
            KE: {
                amount: 2_500,
                currency: 'KES'
            }
        }
    },
    // Lite
    {
        name: PlanNames.liteMonthly,
        displayName: 'Lite',
        maxTransferSize: 200 * GB,
        maxStorageSize: 1 * TB,
        renewalRate: 'monthly',
        allowPurchase: true,
        allowRenew: true,
        maxMembers: 2,
        maxProjects: Infinity,
        defaultPrice: {
            amount: 10,
            currency: 'USD'
        },
        regionPrices: {
            US: {
                amount: 10,
                currency: 'USD'
            },
            KE: {
                amount: 1_000,
                currency: 'KES'
            }
        }
    },
    {
        name: PlanNames.liteAnnual,
        displayName: 'Lite',
        maxTransferSize: 200 * GB,
        maxStorageSize: 1 * TB,
        renewalRate: 'annual',
        allowPurchase: true,
        allowRenew: true,
        maxMembers: 2,
        maxProjects: Infinity,
        defaultPrice: {
            amount: 100,
            currency: 'USD'
        },
        regionPrices: {
            US: {
                amount: 100,
                currency: 'USD'
            },
            KE: {
                amount: 10_000,
                currency: 'KES'
            }
        }
    },
    // Pro
    {
        name: PlanNames.proMonthly,
        displayName: 'Pro',
        maxTransferSize: 1 * TB,
        maxStorageSize: 5 * TB,
        renewalRate: 'monthly',
        allowPurchase: true,
        allowRenew: true,
        maxMembers: 6,
        maxProjects: Infinity,
        defaultPrice: {
            amount: 40,
            currency: 'USD'
        },
        regionPrices: {
            US: {
                amount: 40,
                currency: 'USD'
            },
            KE: {
                amount: 4_000,
                currency: 'KES'
            }
        }
    },
    {
        name: PlanNames.proAnnual,
        displayName: 'Annual',
        maxTransferSize: 200 * GB,
        maxStorageSize: 5 * TB,
        renewalRate: 'annual',
        allowPurchase: true,
        allowRenew: true,
        maxMembers: 6,
        maxProjects: Infinity,
        defaultPrice: {
            amount: 400,
            currency: 'USD'
        },
        regionPrices: {
            US: {
                amount: 400,
                currency: 'USD'
            },
            KE: {
                amount: 40_000,
                currency: 'KES'
            }
        }
    },
    // Business
    {
        name: PlanNames.businessMonthly,
        displayName: 'Business',
        maxTransferSize: 200 * GB,
        maxStorageSize: 25 * TB,
        renewalRate: 'monthly',
        allowPurchase: true,
        allowRenew: true,
        maxMembers: Infinity,
        maxProjects: Infinity,
        defaultPrice: {
            amount: 200,
            currency: 'USD'
        },
        regionPrices: {
            US: {
                amount: 200,
                currency: 'USD'
            },
            KE: {
                amount: 20_000,
                currency: 'KES'
            }
        }
    },
    {
        name: PlanNames.businessAnnual,
        displayName: 'Business',
        maxTransferSize: 200 * GB,
        maxStorageSize: 25 * TB,
        renewalRate: 'annual',
        allowPurchase: true,
        allowRenew: true,
        maxMembers: Infinity,
        maxProjects: Infinity,
        defaultPrice: {
            amount: 2_000,
            currency: 'USD'
        },
        regionPrices: {
            US: {
                amount: 2_000,
                currency: 'USD'
            },
            KE: {
                amount: 200_000,
                currency: 'KES'
            }
        }
    }
];
export const PlanInfoMap = PlanList.reduce((map, plan) => {
    map[plan.name] = plan;
    return map;
}, {});
export function getPlanInfoByName(name) {
    const info = PlanInfoMap[name];
    if (!info) {
        throw new Error(`Could not find plan info for '${name}'`);
    }
}
//# sourceMappingURL=plans.js.map